<template>
	<div
		v-click-outside="onClickOutside"
		class="dropdown"
		:class="{ 'is-active': active }"
	>
		<div class="dropdown-trigger">
			<button
				class="button"
				:disabled="disabled"
				aria-haspopup="true"
				aria-controls="dropdown-menu"
				@click.prevent="toggle"
			>
				<span>{{ label }}</span>
			</button>
		</div>
		<div id="dropdown-menu" class="dropdown-menu" role="menu">
			<div class="dropdown-content">
				<slot></slot>
			</div>
		</div>
	</div>
</template>

<script>
import vClickOutside from "v-click-outside";

export default {
	directives: {
		clickOutside: vClickOutside.directive
	},
	props: {
		disabled: {
			type: Boolean,
			default: () => false
		},
		label: {
			type: String,
			default: () => ""
		}
	},
	data() {
		return {
			active: false
		};
	},
	methods: {
		toggle() {
			this.active = !this.active;
		},
		onClickOutside() {
			this.active = false;
		}
	}
};
</script>

<style lang="scss" scoped>
.dropdown-trigger {
	&::after {
		border: 3px solid transparent;
		border-radius: 2px;
		border-right: 0;
		border-top: 0;
		content: " ";
		display: block;
		height: 0.625em;
		margin-top: -0.4375em;
		pointer-events: none;
		position: absolute;
		top: 50%;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		-webkit-transform-origin: center;
		transform-origin: center;
		width: 0.625em;
		border-color: #4a4a4a;
		right: 1.125em;
		z-index: 4;
	}

	.button {
		padding-right: 2.5rem;
	}
}
</style>
<style scoped>
.dropdown >>> .dropdown-menu {
	display: none;
}
.dropdown.is-active >>> .dropdown-menu {
	display: block;
}
</style>
